// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"VQYdEa"};